// 全局SEO主要内容
export const title = '岗位库简历助手 - 开源免费 | AI智能简历生成工具';
export const keywords =
  '开源免费AI简历生成器,AI简历生成,免费简历制作工具,PDF简历导出,JSON简历模板,deepseek简历优化,AI智能润色简历,AI简历诊断,Markdown导出';
export const description =
  '岗位库简历助手：开源免费AI简历生成器，一键导出高清PDF/JSON/Markdown格式，AI智能润色，AI智能简历诊断，快速生成专业简历模板，100%免费！';
